var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// External dependencies
import { useFormik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
// Internal dependencies
import { TextFieldSG, ButtonSG } from '../components';
import { axiosClient } from '../axios';
import { ENDPOINTS, LOG_LEVELS, SERVICES } from '../constants';
;
/**
 * Email Form
 * @param {any} props
 * @returns {JSX.Element}
 */
export const EmailForm = function (props) {
    const { onSubmit } = props;
    const { t } = useTranslation();
    // Validate schema
    const validationSchema = yup.object({
        email: yup
            .string()
            .email('Invalid email address')
            .required('Required'),
    });
    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationSchema,
        validateOnChange: false,
        onSubmit: (values) => __awaiter(this, void 0, void 0, function* () {
            try {
                onSubmit(values.email);
            }
            catch (err) {
                axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                    level: LOG_LEVELS.ERROR,
                    logMessage: `EmailForm, onSubmit, ${err === null || err === void 0 ? void 0 : err.message}`,
                    metadata: {
                        env: process.env.ENV,
                        service: SERVICES.SIGN_IN,
                        userId: null,
                        email: null,
                        userAgent: navigator === null || navigator === void 0 ? void 0 : navigator.userAgent,
                    },
                });
                toast.error(t('Something went wrong. We are figuring it out.'));
            }
        })
    });
    return (_jsxs("form", Object.assign({ 
        // Email form
        onSubmit: (e) => { e.preventDefault(); formik.handleSubmit(e); } }, { children: [_jsx(TextFieldSG
            // Email input
            , { 
                // Email input
                name: "email", label: "Email", placeholder: 'clare@studioglobal.ai', value: formik.values.email, onChange: formik.handleChange, error: formik.touched.email && Boolean(formik.errors.email), helperText: formik.touched.email && formik.errors.email, xstyles: { padding: '0 0 1rem' } }), _jsx(ButtonSG, Object.assign({ variant: "contained", type: "submit", xstyles: { width: '100%' } }, { children: t('Continue') }))] })));
};
